var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "down-app" }, [
      _c("div", { staticClass: "left" }, [
        _c(
          "svg",
          {
            staticClass: "icon",
            attrs: { slot: "image", "aria-hidden": "true" },
            slot: "image"
          },
          [_c("use", { attrs: { "xlink:href": "#icon-H5xiazailogo" } })]
        ),
        _vm._v(" "),
        _c("div", [
          _c("p", { staticClass: "content" }, [
            _vm._v(_vm._s(_vm.$t("300029")))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tip" }, [_vm._v(_vm._s(_vm.$t("300030")))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c(
          "svg",
          {
            staticClass: "icon",
            attrs: { slot: "image", "aria-hidden": "true" },
            on: {
              click: function($event) {
                return _vm.$router.push("/download")
              }
            },
            slot: "image"
          },
          [_c("use", { attrs: { "xlink:href": "#icon-xiazaitubiao" } })]
        ),
        _vm._v(" "),
        _c("i", {
          staticClass: "iconfont icon-H5xiazaiguanbi",
          on: { click: _vm.close }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12bed60e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12bed60e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/appDown.vue
// module id = WUAA
// module chunks = 0